/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { GroupSelectorModal } from 'components';
import { ListView } from 'model/state';
import { Location, LocationType, isLocationFullAccess } from 'model';
import { useTranslation } from 'react-i18next';

type ParentSelectorProps = {
  show:               boolean;
  onHide:             () => void;
  title:              string;
  subtitle:           string;
  onSelect:           (value: string) => void;
  userLocations:      ListView<Location>;
  type:               LocationType;
  fetchUserLocations: (userId: string, types: LocationType[], page: number, search?: string) => void;
  userId?:            string | null;
  parentId?:          string;
}

export const ParentSelector: React.FC<ParentSelectorProps> = React.memo(({show, userLocations, fetchUserLocations, userId, type, parentId, ...rest}) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (show && userId) {
      fetchUserLocations(userId, type === LocationType.PROPERTY ? [LocationType.PROPERTY] : type === LocationType.BUILDING ? [LocationType.BUILDING] : [LocationType.REGION], 1);
    }
  }, [show]);

  return (
    <GroupSelectorModal
      {...rest}
      show              = {show}
      options           = {userLocations.rows?.filter(l => l.id !== parentId).map(loc => ({ value: loc.id || '', text: loc.nickname || '', disabled: !isLocationFullAccess(loc) })) || []}
      hasMore           = {(userLocations.total || 0) > (userLocations.rows?.length || 0)}
      page              = {userLocations.page}
      isLoading         = {userLocations.isLoading}
      searchPlaceholder = {type === LocationType.PROPERTY ? t('search-properties') : type === LocationType.BUILDING ? t('search-buildings') : t('search-regions')}
      onLoadOptions     = {(search: string | undefined, page: number) => {
        fetchUserLocations(
          userId as string,
          type === LocationType.PROPERTY ? [LocationType.PROPERTY] : type === LocationType.BUILDING ? [LocationType.BUILDING] : [LocationType.REGION],
          page,
          search
        );
      }}
    />
  );
});
